export const SET_REST_CONNECTION = 'REST/SET_REST_CONNECTION';

export const setRestConnection = (client) => {
  return (dispatch) => {
    dispatch({ type: SET_REST_CONNECTION, payload: client });
  };
};

export default function reducer(
  state = {
    rest: null,
  },
  action
) {
  switch (action.type) {
    case SET_REST_CONNECTION:
      return {
        ...state,
        rest: action.payload,
      };
    default:
      return state;
  }
}